module.exports = __webpack_public_path__ + "static/media/america-express-icon.c894689c.svg";